/* 曹丕（字子桓） */
import { SG, gd, spMul } from '../../core/kit.ts';
import { defineHero, hook, U, P } from '../define.ts';

export default defineHero({
  id: 'caopi', name: '曹丕', sub: '字子桓', faction: 'wei', role: '法師', weapon: 'sword',
  look: { ranged: true, head: 'crown', robe: true, beard: 'mustache', eye: 'narrow', fx: '#ff8a5a', c: { cloth: '#5a1f2a', sleeve: '#5a1f2a', armor: '#d9b45c', cape: '#8a1f2a', trim: '#e9c46a' } },
  skills: [
    ['煮豆燃萁', 'fire', '對一名敵人點火，立即 {80/120/160/200} 火傷害；之後只要他移動累計 700 距離就再爆一次 {100/150/200/250}，5 秒內沒走完就熄滅。想逃就會被燒。', { x: { k: 'beans', dmg: [80, 120, 160, 200], boom: [100, 150, 200, 250] }, aim: U(550), cd: [12, 11, 10, 9], mp: [70, 80, 90, 100], el: 'fire' }],
    ['典論', 'passive', '每放一招得 1 層「文」，3 層時下一招傷害 +{20/30/40/50}%，並返還 50% 耗氣。', { pv: {}, sig: 'dianlun', amp: [20, 30, 40, 50], stack: 'dlN', max: 3 }],
    ['九品中正', 'trap', '在指定地點立起官印 3 秒，範圍內敵人緩速 {20/30/40/50}%，友軍每秒回復 {10/15/20/25} 氣。', { x: { k: 'nine', r: 240, dur: 3, slow: [20, 30, 40, 50], mp: [10, 15, 20, 25] }, aim: P(600, 240), cd: 16, mp: [70, 80, 90, 100], el: 'holy' }],
    ['受禪', 'command', '指定一名敵將，奪走他的大招：20 秒內再按 R，就以自己的數值放一次這招；對方的大招被鎖 {6/8/10} 秒。對方大招是被動時，改為造成 {200/300/400} 傷害。', { x: { k: 'abdicate', lock: [6, 8, 10], dmg: [200, 300, 400] }, aim: U(600), cd: [90, 75, 60], mp: [150, 175, 200], el: 'shadow', shout: '天命在魏，漢祚當終！' }],
  ],
  // 專屬技能（技能資料裡的 x.k）
  kinds: {
    beans(u, a, X) {
      const t = this.xPick(u, a.pt, 150);
      if (!t) { this.xRefund(u, a); return; }
      const sp = spMul(u);
      this.damage(u, t, X.dmg * sp, { magic: true, spell: true, stagger: 0.25, fire: true });
      this.fx({ k: 'fire', x: t.x, y: t.y, pal: 'fire' });
      if (t.alive) t.bean = { by: u, dist: 0, last: [t.x, t.y], until: this.t + 5, dmg: X.boom * sp };
    },
    nine(u, a, X) {
      this.zone(u, { x: a.pt[0], y: a.pt[1], r: X.r, t: X.dur, tick: 0.5, slow: X.slow / 100, ground: true, name: a.sk.name, x2: { mpAlly: X.mp } });
      this.fx({ k: 'slam', x: a.pt[0], y: a.pt[1], col: '#ffe9a8' });
    },
    abdicate(u, a, X) {
      const t = this.xPick(u, a.pt, 150);
      if (!t || t.kind !== 'hero') { this.xRefund(u, a); this.tell(u, '受禪：要指定敵將', 'warn'); return; }
      const sk = t.spec.skills[3];
      t.cd[3] = Math.max(t.cd[3], X.lock);
      this.fx({ k: 'thunder', x: t.x, y: t.y, col: '#ff8a5a' });
      if (!sk || sk.passive || sk.tg || sk.recast) { // 被動或特殊大招：改成傷害
        this.damage(u, t, X.dmg * spMul(u), { magic: true, spell: true, stagger: 0.4 });
        this.tell(u, `受禪：${t.name} 的大招無法奪取，改為重創並鎖住`, 'info');
        return;
      }
      u.stolen = { sk, lvl: Math.max(1, t.skillLv[3] || 1), until: this.t + 20, from: t.name };
      this.say(`${u.name}：「${a.sk.shout}」奪取 ${t.name} 的「${sk.name}」！`, 'big');
    },
  },
  // 被動與專屬效果：hook(時間點, 順位, 處理)（時間點一覽見 core/hooks.ts）
  hooks: [
    // 受禪：手上有奪來的大招時，按 R 放那一招（免耗氣）
    hook('cast.before', 10, function (u, i, x, y) {
      if (i === 3 && u.stolen && u.stolen.until > this.t && u.st.silence <= 0 && !u.act) {
        const st = u.stolen; u.stolen = null;
        this.beginSkill(u, 3, st.sk, st.lvl, x, y);
        this.tell(u, `受禪：施放「${st.sk.name}」`, 'info');
        return true;
      }
    }),
    // 典論：放招之前記下「文」是否已經三疊
    hook('cast.pre', 5, function (u, i, x, y) { const dl = u.sg && u.sg.dianlun; u.dlReady = dl && u.dlN >= 3; }),
    // 典論：每放一招得 1 層「文」，3 層時這一招返還一半耗氣、傷害加成
    hook('cast.after', 60, function (u, i, sk) {
      const dl = u.sg && u.sg.dianlun, ready = u.dlReady;
      if (dl) {
        if (ready) {
          u.dlN = 0; u.mp = Math.min(u.maxMp, u.mp + this.skillCost(i, u.skillLv[i], sk) / 2);
          const base = u.sp || 0, amp = dl.v('amp'); u.sp = base + amp;
          this.later(2.5, () => { if (u.sp === base + amp) u.sp = base; });
          this.tell(u, '典論：文氣三疊，這一招強化', 'info');
        } else u.dlN = (u.dlN || 0) + 1;
      }
    }),
    hook('tick', 140, function (u, dt) { if (u.stolen && u.stolen.until <= this.t) { u.stolen = null; this.tell(u, '受禪：奪來的大招過期了', 'warn'); } }),
    // 煮豆燃萁：被點火的人累計移動 700 就爆
    hook('step.end', 10, function (dt) {
      for (const t of this.units) {
        const b = t.bean;
        if (!b) continue;
        if (!t.alive || b.until <= this.t) { t.bean = null; continue; }
        b.dist += gd(t.x, t.y, b.last[0], b.last[1]); b.last = [t.x, t.y];
        if (b.dist >= 700) { t.bean = null; this.damage(b.by, t, b.dmg, { magic: true, spell: true, stagger: 0.3, fire: true }); this.fx({ k: 'fire', x: t.x, y: t.y, pal: 'fire' }); this.fx({ k: 'slam', x: t.x, y: t.y, col: '#ff8a3a' }); }
      }
    }),
    // 九品中正：區域內的友將回氣
    hook('zone', 5, function (z, dt) { const e = z.x2; if (e.mpAlly) for (const t of this.units) if (t.alive && t.kind === 'hero' && t.team === z.team && gd(z.x, z.y, t.x, t.y) <= z.r && !SG.isNeng(t)) t.mp = Math.min(t.maxMp, t.mp + e.mpAlly * dt); }),
  ],
  // 電腦什麼時候放這招
  ai: {
    beans: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 550,
    nine: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 600,
    abdicate: ({ w, u, t, d, hero, hpR, foeHeroes }) => hero && d < 600,
  },
});
